'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType from "./presto.ui.-Inputs$-Input-Type.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_Inputs$InputType$$anon$5(_$ordinal$2, \u03b4name$2, outer) {
  this.czg = 0;
  this.aay = null;
  this.czg = _$ordinal$2;
  this.aay = \u03b4name$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_ui_Inputs$InputType$$anon$5 as $c_Lpresto_ui_Inputs$InputType$$anon$5 };
$p = $c_Lpresto_ui_Inputs$InputType$$anon$5.prototype = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType.$h_Lpresto_ui_Inputs$InputType();
$p.constructor = $c_Lpresto_ui_Inputs$InputType$$anon$5;
/** @constructor */
function $h_Lpresto_ui_Inputs$InputType$$anon$5() {
}
export { $h_Lpresto_ui_Inputs$InputType$$anon$5 as $h_Lpresto_ui_Inputs$InputType$$anon$5 };
$h_Lpresto_ui_Inputs$InputType$$anon$5.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.aay;
});
$p.l = (function() {
  return this.aay;
});
var $d_Lpresto_ui_Inputs$InputType$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_Inputs$InputType$$anon$5, "presto.ui.Inputs$InputType$$anon$5", ({
  a4c: 1,
  a4a: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_ui_Inputs$InputType$$anon$5 as $d_Lpresto_ui_Inputs$InputType$$anon$5 };
//# sourceMappingURL=presto.ui.-Inputs$-Input-Type$$anon$5.js.map
